import { presetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import type { IAnimMediaControl } from '../anim-interface';
import type { IMediaManager, VideoType } from '@src/slide/application/service/media-manager/media-manager.interface';
import type { IMediaParams } from '@src/slide/application/service/media-manager/params.interface';
import { AnimType } from '@tencent/slide-sdk-model';

export default class AnimMediaControl implements IAnimMediaControl {
    protected handlerMap: Map<string | undefined, () => void>;
    protected elementModel: any;
    protected animType: string | undefined;
    protected animStopAtLength?: number;

    public constructor(protected mediaManager: IMediaManager) {
        this.handlerMap = new Map();
        this.handlerMap.set(AnimType.Play, () => this.playHandler());
        this.handlerMap.set(AnimType.Pause, () => this.togglePauseHandler());
        this.handlerMap.set(AnimType.Stop, () => this.stopHandler());
    }

    /**
     * 动画开始时，处理media元素
     * @param mediaParams
     */
    public startMediaControl(mediaParams: IMediaParams): void | undefined {
        const { elementModel, animType, presetClass, animStopAtLength } = mediaParams;
        this.elementModel = elementModel;
        this.animType = animType;
        this.animStopAtLength = animStopAtLength;

        // 1.media元素上是常规动画，而不是对media播放的控制
        if (presetClass !== presetClassTypes.MEDIA) {
            // 停止播放
            this.stopHandler();
            return;
        }

        // 2.media元素上无常规动画，有mediacall类型动画控制media的播放
        this.handleMediaAnimStart();
    }

    /**
     * 动画结束时，处理mediacall类型
     * @param mediaParams
     * @returns
     */
    public completeMediaControl(mediaParams: IMediaParams): void | undefined {
    }

    // 检查media是否正在播放
    public isPlaying(): boolean {
        return false;
    }
    // media开始播放
    protected playHandler(startTime?: number): void {}

    // media togglePause播放, 若音视频播放则暂停，若音视频暂停则播放
    protected togglePauseHandler(): void {}

    // media停止播放
    protected stopHandler(): void {}

    /**
     * 获取media实例
     * @returns media实例
     */
    protected getMediaInstance(elementModelKey: string): HTMLAudioElement | VideoType | null {
        return null;
    }


    /**
     * 动画开始时，处理mediacall类型的动画
     */
    private handleMediaAnimStart(): void {
        this.handlerMap.get(this.animType)?.();
    }
}
